/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import useProfileSizes from '~/pdp/utils/useProfileSizes';
import { getIsPlusProfile } from '~/shared/utils/getIsPlusProfile';
import { useBreakpoint } from '~/techstyle-shared/react-components';

import {
  buildFallbackImageFromCDN,
  getImageUrlFromImageSet,
} from '../../utils/images';

const ProductCardImageFromImageSet = ({ images = [], swatchLabel }) => {
  const [isHovered, setIsHovered] = useState(false);
  const { profileSizes } = useProfileSizes({ isPdp: false });
  const isPlusProfile = getIsPlusProfile(profileSizes);
  const { isMobile } = useBreakpoint();

  const primaryImageUrl = getImageUrlFromImageSet({
    imageSet: images,
    isPlusProfile,
    requestedAngle: '1',
    requestedWidth: isMobile ? 327 : 577,
    requestedHeight: isMobile ? 491 : 866,
  });
  const hoverImageUrl = getImageUrlFromImageSet({
    imageSet: images,
    isPlusProfile,
    requestedAngle: '2',
    requestedWidth: isMobile ? 327 : 577,
    requestedHeight: isMobile ? 491 : 866,
  });

  const handleImageLoaded = (e) => {
    // TODO: handle skeleton loading by default, then smoothly transition skeleton loader to actual image
    // May need additional state to track loading
  };

  const handleImageError = (e) => {
    e.target.onerror = null; // prevents looping
    e.target.src = buildFallbackImageFromCDN({
      width: isMobile ? 327 : 577,
      height: isMobile ? 491 : 866,
    });
  };

  // Preload the hover image
  useEffect(() => {
    const image = new Image();
    image.src = hoverImageUrl;
  }, [hoverImageUrl]);

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <img
        src={isHovered ? hoverImageUrl : primaryImageUrl}
        alt={swatchLabel}
        title={swatchLabel}
        onError={handleImageError}
        onLoad={handleImageLoaded}
      />
    </div>
  );
};

ProductCardImageFromImageSet.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      angle: PropTypes.string.isRequired,
      sizes: PropTypes.arrayOf(
        PropTypes.shape({
          width: PropTypes.number.isRequired,
          height: PropTypes.number.isRequired,
          url: PropTypes.string.isRequired,
        })
      ).isRequired,
    })
  ),
  swatchLabel: PropTypes.string.isRequired,
};

export default ProductCardImageFromImageSet;
